module.exports = {"441602001":"上城街道","441602002":"新江街道","441602003":"东埔街道","441602004":"源西街道","441602005":"高埔岗街道","441602006":"城东街道","441602100":"源南镇","441602101":"埔前镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441602.json
// module id = 2036
// module chunks = 0